/**
 * Состояние кнопки «Серия»: видна ли, живая ли и что говорит.
 *
 * Отдельно от разметки, потому что это правило о смысле, а не о вёрстке.
 * «Карты» серию не снимают вовсе — она начинается с кадра сноса и трека HSI,
 * которых там не бывает, — и кнопки там нет. А внутри «Аналитики» кнопка не
 * исчезает, а гаснет и называет причину: молча пропавшая кнопка не объясняет,
 * почему её нет, и человек ищет её в настройках.
 *
 * С 07.09.2026 причина осталась ОДНА. Прежние две («вид не выбран», «для этого
 * вида серия не задана») описывали реестр, которого больше нет: состав
 * считается из каталога слоёв и от вида не зависит — от вида зависит один кадр
 * «Комфортной среды». Молчать кнопка может лишь пока каталог не приехал.
 */
export interface SeriesButtonState {
  shown: boolean
  disabled: boolean
  /** Ключ подсказки; null — сказать нечего. */
  hintKey: string | null
}

export function seriesButtonState(
  series: { ready: boolean; reason: 'ok' | 'no-series' } | undefined,
  busy = false,
): SeriesButtonState {
  if (!series) return { shown: false, disabled: true, hintKey: null }
  if (series.ready) {
    // Занятость чужой работой причиной отсутствия серии не объясняем: подсказка
    // «для этого вида серия не задана» во время записи MP4 была бы ложью.
    return { shown: true, disabled: busy, hintKey: null }
  }
  return { shown: true, disabled: true, hintKey: 'map.export.seriesNoLayers' }
}
